<template>
  <div>
    <tx-action txType="Claim" />
    <div class="d-flex justify-center mt-16">
      <div class="deposit-box pa-10">
        <c-tx-steps
          class="mt-6"
          borderType="stake"
          :options="steps"
          :current="currentStep"
          @setStep="s => (currentStep = s)"
        />
        <div v-if="currentStep === 1">
          <c-loading v-if="rewards.fetching" />
          <select-ecosystem :ecosystem="ecosystem" />
          <div class="d-flex mt-16">
            <div>
              <div class="text-5 font-weight-medium">Claimable Rewards</div>
              <div class="mt-2 text-2">
                <div class="d-flex align-center">
                  <span class="primary--text">{{
                    rewardsBalance | denomFormat
                  }}</span>
                  <span class="gray--text text-uppercase ml-1">{{
                    currentProject.staking.token
                  }}</span>
                  <img
                    :src="
                      ($vuetify.theme.dark
                        ? currentProject.logoSmallDark
                        : currentProject.logoSmall) || currentProject.logoSmall
                    "
                    height="36"
                    width="36"
                    class="ml-4"
                  />
                </div>
              </div>
              <div class="mt-1 darkgray--text text-5">
                ${{ rewardsUsd | currency }}
              </div>
            </div>
          </div>
          <div class="mt-10">
            <v-select
              :items="validators"
              v-model="form.validatorId"
              item-value="id"
              class="c-input search-stake mt-3"
              placeholder="Select validator to claim rewards"
              outlined
              hide-details
            >
              <template v-slot:item="{ item }">
                <div class="flex-1 d-flex align-center justify-space-between">
                  <div class="text-4">
                    {{ item.name }}
                  </div>
                  <div class="text-5  gray--text">
                    <span>
                      {{ item.rewards.unclaimed | denomFormat }}
                    </span>
                    <span class="ml-1">
                      {{ currentProject.staking.token | uppercase }}
                    </span>
                  </div>
                </div>
              </template>
              <template v-slot:selection="{ item }">
                <div
                  class="flex-1 d-flex align-center justify-space-between selection-item"
                >
                  <div class="text-4">
                    {{ item.name }}
                  </div>
                  <div class="text-5 gray--text">
                    <span>
                      {{ item.rewards.unclaimed | denomFormat }}
                    </span>
                    <span class="ml-1">
                      {{ currentProject.staking.token | uppercase }}
                    </span>
                  </div>
                </div>
              </template>
            </v-select>
          </div>
          <div class="mt-16">
            <c-btn
              class="width-100"
              @click="next"
              :disabled="btnNextDisabled"
              walletRequired
              >Continue</c-btn
            >
          </div>
        </div>
        <confirm
          @close="$emit('close')"
          v-if="currentStep === 2"
          :txPayload="form"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TxAction from "@/views/stake/components/tx/TxAction.vue";
import Confirm from "./Confirm.vue";
import SelectEcosystem from "@/views/stake/components/tx/SelectEcosystem.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    TxAction,
    Confirm,
    SelectEcosystem,
  },
  computed: {
    ...mapGetters({
      walletSelected: "userWallets/walletSelected",
      currentProject: "projectConfig/latestProject",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      rewards: "staking/skale/rewards",
    }),
    rewardsBalance() {
      return this.rewards.result?.value || 0;
    },
    rewardsUsd() {
      return (
        this.rewardsBalance *
        this.getTokenPriceInUsd(this.currentProject.staking.token)
      );
    },
    validators() {
      return this.rewards.result?.rewards || [];
    },
    btnNextDisabled() {
      if (!this.currentProject.status?.active) return true;
      return !this.form.validatorId;
    },
  },
  data: () => ({
    ecosystem: "Ethereum",
    steps: [
      {
        step: 1,
        text: "Select validator",
      },
      {
        step: 2,
        text: "Confirm",
      },
    ],
    currentStep: 1,
    form: {
      validatorId: null,
    },
  }),
  methods: {
    next() {
      this.currentStep = 2;
    },
  },
  watch: {
    ["walletSelected.address"]() {
      this.currentStep = 1;
      this.form.validatorId = null;
    },
    validators(values) {
      if (!this.form.validatorId && values.length) {
        this.form.validatorId = values[0].id;
      }
    },
  },
};
</script>
